import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';

// assets
import { faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services

// props

// components
import { ActionButton, CommandBar, DefaultButton, ICommandBarItemProps, Panel, PanelType, Pivot, PivotItem, PrimaryButton, Stack } from '@fluentui/react';
import ErrorService from '../../../../../services/general/error';
import LoadingComponent from '../../../../feedbacks/loading';
import ComingSoon from '../../../../uiframeworks/comingSoon';
import OrderAddonDetailsProperties from './properties';
import OrderAddonForm from '../form';
import PermissionsService from '../../../../../services/permissions';
import { IOrderAddonResourceProps } from '../../../../../props/orders/orderAddon';
import DeleteOrderAdditionalChargeForm from '../form/delete';
import OrderAddOnService from '../../../../../services/orders/odrerAddOn';

interface OrderAddonDetailsProps {
    orderId: string;
    addonId: string;
    onDismissed(refresh?: boolean): void;
}

const OrderAddonDetails: React.FC<OrderAddonDetailsProps> = (props: OrderAddonDetailsProps) => {
    const { banner, user } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [addon, setAddon] = React.useState<IOrderAddonResourceProps | undefined>();
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setLoaded(false);
            const _addon = await OrderAddOnService.get(props.orderId, props.addonId);
            setAddon(_addon);
            setLoaded(true);
        } catch (error) {
            banner.add({
                key: "get_order_addon_details_error",
                text: "Sorry, we encounter an issue. Error: " + ErrorService.getMessage(error),
                variant: 'error',
                icon: faXmarkCircle
            });
        }
    }

    const getCommandBarItems = () => {
        const items: ICommandBarItemProps[] = [];
        const farItems: ICommandBarItemProps[] = [];

        if (PermissionsService.hasPermission(['orders.update.all'], user.permissions)) {
            items.push({
                key: 'update',
                text: 'Update',
                onRender: () => {
                    return <PrimaryButton text={'Update'}
                        onClick={() => {setActiveSurface('addon.update');}}
                        styles={{ root: { marginRight: 20 } }} />
                }
            });
        }

        if (PermissionsService.hasPermission(['orders.update.all'], user.permissions)) {
            farItems.push({
                key: 'delete',
                text: 'Delete',
                onRender: () => {
                    return <ActionButton iconProps={{ iconName: "Delete" }} text={"Delete"} onClick={() => setActiveSurface('addon.delete')} />
                }
            })
        }

        return { items, farItems };
    }

    const _onSurfaceDismissed = (refresh?: boolean) => {
        setActiveSurface(undefined);
        if (refresh) { init(); }
    }

    return <Panel headerText={addon?.name || "Addon Details"}
        isOpen={true}
        type={PanelType.large}
        onDismiss={() => props.onDismissed(true)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <DefaultButton text={"Close"} onClick={() => { props.onDismissed(true) }} />
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }}>
            {!loaded ? <LoadingComponent label='Retrieving details ...' labelPosition='right' spinnerPosition='baseline' /> : null}
            {loaded && addon ? <>
                <CommandBar {...getCommandBarItems()} styles={{ root: { padding: 0, margin: 0 } }} />
                <Pivot className={'linePivot'}>
                    <PivotItem key={'details'} headerText={"Details"}>
                        <Stack styles={{ root: { padding: 10 } }}><OrderAddonDetailsProperties addon={addon} /></Stack>
                    </PivotItem>
                    <PivotItem key={'trackings'} headerText={"Trackings"}>
                        <Stack><ComingSoon /></Stack>
                    </PivotItem>
                    <PivotItem key={'documents'} headerText={"Documents"}>
                        <Stack><ComingSoon /></Stack>
                    </PivotItem>
                </Pivot>
            </> : null}
        </Stack>
        {activeSurface === 'addon.update' ? <OrderAddonForm orderId={props.orderId} additionalChargeId={props.addonId} onDismissed={_onSurfaceDismissed} /> : null}
        {activeSurface === 'addon.delete' && addon ? <DeleteOrderAdditionalChargeForm additionalCharge={addon} onDismissed={props.onDismissed} /> : null}
    </Panel>
};

export default OrderAddonDetails;
